import React from 'react'

import { Element, Text, TextLink } from "components/shared/base"
import {
  PrismicFooterDataType,
} from "types/__generated__/gatsby-graphql"
import { colors } from "theme/colors"


export type FooterContactInfoProps = PrismicFooterDataType

const FooterContactInfo: React.FC<FooterContactInfoProps> = ({
  contact_us_link,
  contact_us_text,
  signature
}): React.ReactElement => {
  const date = new Date();
  const contactUsLink = contact_us_link?.url;

  return (
    <Element gridColumnEnd={["auto", "span 6", "span 4", "span 3"]} pl={["0", "20px"]} ml="auto">
      <Text>{signature} {date.getFullYear()}</Text>
      {contactUsLink && contact_us_text && (
        <Text mt="5px">
          <TextLink
            color={colors.textFooter}
            externalLink={true}
            href={contactUsLink}
            text={contact_us_text} />
        </Text>
      )}
    </Element>
  )
}

export default FooterContactInfo
